import { render, staticRenderFns } from "./StuIntro.vue?vue&type=template&id=993e2d46&scoped=true&"
import script from "./StuIntro.vue?vue&type=script&lang=js&"
export * from "./StuIntro.vue?vue&type=script&lang=js&"
import style0 from "./StuIntro.vue?vue&type=style&index=0&id=993e2d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993e2d46",
  null
  
)

export default component.exports